// extracted by mini-css-extract-plugin
module.exports = {"box":"box--Lf6MF","header":"header--2R2pC","logo":"logo--3rSU1","nav":"nav--3U7rh","active":"active--Jg08m","a":"a--DYix8"};